import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, InputAdornment } from '@mui/material';
import { BadgeOutlined } from '@mui/icons-material';
import { useHstAccessEditor } from '../../../../hooks/useHstAccessEditor';
import { useGetHstRolesQuery } from '../../../../../../services/DimensionService/dimensionApi';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const HstRoleEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useHstAccessEditor(mode);
  const { data: hstRoles = [], isLoading } = useGetHstRolesQuery();
  const labelId = `${mode}-hst-role-label`;

  const handleChange = (value: string) => {
    updateRequest({ role: value });
  };

  return (
    <FormControl size="small" fullWidth required>
      <InputLabel id={labelId}>HST Role</InputLabel>
      <Select
        labelId={labelId}
        value={request?.role || ''}
        onChange={(e) => handleChange(e.target.value)}
        label="HST Role"
        disabled={isLoading}
        startAdornment={
          <InputAdornment position="start">
            <BadgeOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        }
      >
        {hstRoles.map((role) => (
          <MenuItem key={role.value} value={role.value}>{role.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default HstRoleEditor;
